import yup from '../../../config/yup';

export const stopIfZeroValidationSchema = yup.object().shape({
  '@id': yup.string().default(''),
  '@data-type': yup.string().default('command'),
  type: yup.string().default('stop_if_zero'),
  action: yup.string().default('STOPIFZERO').required('Action is required'),
  command: yup
    .string()
    .default('STOPIFZERO')
    .required('Command is required')
    .matches(
      /^STOPIFZERO\s+\S+/i,
      "Command must start with 'STOPIFZERO' followed by at least one word"
    ),
});
